<template>
  <v-container id="main" class="d-flex justify-center" fill-height fluid>
    <v-card class="pa-5" width="400px">
      <v-card-text>
        <v-img :src="require('@/assets/logo-milos-gscv.png')" class="mb-8"></v-img>
        <v-alert v-if="errorMessage" type="error" dismissible class="ma-4">
          {{ errorMessage }}
        </v-alert>
        <v-form v-on:submit.prevent="submit">
          <v-text-field v-model="username" label="Username" variant="outlined" density="comfortable"></v-text-field>
          <v-text-field v-model="password" label="Password" variant="outlined" density="comfortable"
                        :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
                        :type="showPassword ? 'text' : 'password'"
                        @click:append="showPassword = !showPassword"></v-text-field>
          <v-btn type="submit" color="primary" block>{{ $t('label.login') }}</v-btn>
        </v-form>
      </v-card-text>
    </v-card>

  </v-container>
</template>

<script>
import {mapActions} from 'vuex'

export default {
  name: "LandingPageCircle",
  data() {
    return {
      username: '',
      password: '',
      showPassword: false,
      appTitle: process.env.VUE_APP_TITLE,
      errorMessage: null
    }
  },
  mounted() {
    this.errorMessage = localStorage.getItem('errorMessage');
    localStorage.removeItem('errorMessage');
  },
  created() {
    const user = localStorage.getItem('user');
    if (user && user !== 'null' && user !== 'undefined') {
      this.$router.push('/app');
    }
  },
  methods: {
    ...mapActions('account', ['loginCircle']),
    submit() {
      const {username, password} = this;
      if (username && password) {
        this.loginCircle({username, password}).catch(error => {
          this.errorMessage = error;
          localStorage.setItem('errorMessage', this.errorMessage);
        })
      }
    }
  }
}
</script>

<style scoped>

</style>